export const TEMPLATES = {
  "소설": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "인물관계도", type: "relationship" },
    { label: "가장 공감한 인물", type: "text", placeholder: "인물 이름과 그 이유는?" },
    { label: "감정 흐름", type: "textarea", placeholder: "읽으면서 어떤 감정이 들었나요?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "에세이": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "가장 공감한 부분", type: "textarea", placeholder: "어떤 부분이 가장 와닿았나요?" },
    { label: "작가의 시선", type: "textarea", placeholder: "작가는 어떤 사람인 것 같나요?" },
    { label: "내 삶에 적용할 점", type: "textarea", placeholder: "이 책에서 얻은 것을 어떻게 적용할 건가요?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "시": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "가장 좋아하는 시", type: "quote", placeholder: "제목 또는 기억에 남는 구절을 적어보세요." },
    { label: "이미지와 감각", type: "textarea", placeholder: "어떤 이미지나 감각이 떠올랐나요?" },
    { label: "감정", type: "textarea", placeholder: "어떤 감정이 들었나요?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "자기계발": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "핵심 주장", type: "textarea", placeholder: "이 책이 말하는 핵심은 무엇인가요?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "당장 실천할 것", type: "textarea", placeholder: "오늘부터 실천할 수 있는 것 3가지" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "경제": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "핵심 주장", type: "textarea", placeholder: "이 책이 말하는 핵심 경제 원리는?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "내 삶에 적용할 점", type: "textarea", placeholder: "재정/투자에 어떻게 적용할 건가요?" },
    { label: "더 공부할 것", type: "textarea", placeholder: "이 책을 읽고 더 알고 싶어진 것은?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "비즈니스": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "핵심 주장", type: "textarea", placeholder: "이 책이 말하는 핵심은 무엇인가요?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "내 일에 적용할 점", type: "textarea", placeholder: "실무에 어떻게 적용할 건가요?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "역사": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "시대적 배경", type: "textarea", placeholder: "어떤 시대/사건을 다루나요?" },
    { label: "핵심 사건", type: "textarea", placeholder: "가장 인상 깊은 역사적 사건은?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "현재와의 연결", type: "textarea", placeholder: "지금 우리 시대와 어떻게 연결되나요?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "과학": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "핵심 개념", type: "textarea", placeholder: "이 책의 핵심 과학 개념은?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "일상과의 연결", type: "textarea", placeholder: "이 과학적 개념이 일상에서 어떻게 보이나요?" },
    { label: "더 공부할 것", type: "textarea", placeholder: "더 알고 싶어진 것은?" },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "인문": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "핵심 질문", type: "textarea", placeholder: "이 책이 던지는 핵심 질문은?" },
    { label: "나의 답", type: "textarea", placeholder: "그 질문에 대한 나의 생각은?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "생활": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "당장 써먹을 것", type: "textarea", placeholder: "오늘부터 바로 실천할 수 있는 것은?" },
    { label: "인상 깊은 내용", type: "quote", placeholder: "기억하고 싶은 내용을 적어보세요." },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
  "기타": [
    { label: "완독일", type: "date" },
    { label: "한 줄 감상", type: "text", placeholder: "이 책을 다 읽고 난 직후, 마무리 한 문장은?" },
    { label: "핵심 내용", type: "textarea", placeholder: "이 책의 핵심 내용은 무엇인가요?" },
    { label: "인상 깊은 문장", type: "quote", placeholder: "기억하고 싶은 문장을 적어보세요." },
    { label: "나에게 남은 것", type: "textarea", placeholder: "이 책이 내게 남긴 것은 무엇인가요?" },
    { label: "추천하고 싶나요?", type: "rating" },
  ],
};

export function getTemplate(genre) {
  return TEMPLATES[genre] || TEMPLATES["기타"];
}
